export default "__VITE_ASSET__C$QcyhBU__"